import React, { useState, useEffect } from "react";
import Topbar from "./topBar";
import Sidebar from "./sideBar";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { IoSearch } from "react-icons/io5";
import axios from "axios";
import Cookies from "universal-cookie";
import { API as url1 } from "../../config";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { FaRegCheckSquare, FaRegSquare } from "react-icons/fa";
import { Link } from "react-router-dom";
import { ORG_CUSTOMER, ENABLE_OFFER_PATH,ORG_SEARCH_CUSTOMER } from "../../constants/url";
import { privateApiCall } from "../../api/privateApi";
import { ERR_ALERT_TITLE, ERR_GETTING } from "../../constants/alertMessage";

const cookies = new Cookies();
const Customer = () => {
  const [values, setValues] = useState({
    data: [],
    success: false,
    removed: false,
    img1: "",
    img2: "",
    img3: "",
    img4: "",
    keywords: "",
    title: "",
    description: "",
    qty: "",
    price: "",
    unit: "",
    location: "",
    latitude: "",
    longitude: "",
    expdate: "",
    availableDate: "",
    auction_status: "",
    organic_status: "",
    safe_status: "",
    transpot_status: "",
    chargesAfter: "",
    freeDelivery: "",
    startDate: null,
    endDate: null,
  });
  const {
    startDate,
    endDate,
    success,
    removed,
    data,
    img1,
    img2,
    img3,
    img4,
    keywords,
    title,
    description,
    qty,
    price,
    unit,
    location,
    latitude,
    longitude,
    expdate,
    availableDate,
    auction_status,
    organic_status,
    transpot_status,
    safe_status,
    freeDelivery,
    chargesAfter,
  } = values;
  const [image1, setImage1] = useState("");
  const [image2, setImage2] = useState("");
  const [image3, setImage3] = useState("");
  const [image4, setImage4] = useState("");
  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    
  const requestUrl =  `${ORG_CUSTOMER}?_id=${cookies.get("org_id")}&org_name=${cookies.get("org_name")}&startDate=${startDate}&endDate=${endDate}`
       privateApiCall(requestUrl,"GET")
       .then(
        (res) => {
          const k = 1;
          for (let i = 0; i < res.data.length; i++) {
            res.data[i].sno = k + +i;
          }
          setValues({ ...values, data: res.data });
        },
        (err) => {
          Swal.fire({
            title: `${err}`,
            icon: "question",
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonText: "OK",
          });
        }
      )
      .catch((err)=>{
        Swal.fire({
          title: `${ERR_ALERT_TITLE}`,
          icon: `error`,
          text: `${ERR_GETTING}`,
          allowOutsideClick: false,
          showCancelButton: false,
          confirmButtonText: "OK",
        });
      })
    
  };
  const loadData1 = (type, value) => {
    if (type === "start") {
      const requestUrl =  `${ORG_CUSTOMER}?_id=${cookies.get("org_id")}&org_name=${cookies.get("org_name")}&startDate=${value}&endDate=${endDate}`
          privateApiCall(requestUrl,"GET")
          .then(
            (res) => {
              const k = 1;
              for (let i = 0; i < res.data.length; i++) {
                res.data[i].sno = k + +i;
              }
              setValues({ ...values, data: res.data, startDate: value });
            },
            (err) => {
              Swal.fire({
                title: `${err}`,
                icon: "error",
                allowOutsideClick: false,
                showCancelButton: false,
                confirmButtonText: "OK",
              });
            }
          )
          .catch((err)=>{
            Swal.fire({
              title: `${ERR_ALERT_TITLE}`,
              icon: `error`,
              text: `${ERR_GETTING}`,
              allowOutsideClick: false,
              showCancelButton: false,
              confirmButtonText: "OK",
            });
          })
        
    } else {
      
  const requestUrl =`${ORG_CUSTOMER}?_id=${cookies.get("org_id")}&org_name=${cookies.get("org_name")}&startDate=${startDate}&endDate=${value}`
      privateApiCall(requestUrl,'GET')
      .then(
        (res) => {
          const k = 1;
          for (let i = 0; i < res.data.length; i++) {
            res.data[i].sno = k + +i;
          }
          setValues({ ...values, data: res.data, endDate: value });
        },
        (err) => {
          Swal.fire({
            title: `${err}`,
            icon: "error",
            allowOutsideClick: false,
            showCancelButton: false,
            confirmButtonText: "OK",
          });
        }
      )
      .catch((err)=>{
        Swal.fire({
          title: `${ERR_ALERT_TITLE}`,
          icon: `error`,
          text: `${ERR_GETTING}`,
          allowOutsideClick: false,
          showCancelButton: false,
          confirmButtonText: "OK",
        });
      })
   
       
    }
  };

  const handleSearch = async (e) => {
    const searchValue = e.target.value.trim();
    
    try {
      const requestUrl = `${ORG_SEARCH_CUSTOMER}?_id=${cookies.get("org_id")}&org_name=${cookies.get("org_name")}&query=${searchValue}&startDate=null&endDate=null`;
      const response = await privateApiCall(requestUrl, 'GET');
  
      if (Array.isArray(response.data)) {
        const customersWithSno = response.data.map((customer, index) => {
          return {
            ...customer,
            sno: index + 1,
          };
        });
  
        setValues({ ...values, data: customersWithSno });
      } else {
        setValues({ ...values, data: [] }); 
      }
    } catch (error) {
      Swal.fire({
        title: `${ERR_ALERT_TITLE}`,
        text: `${ERR_GETTING}`,
        icon: "error",
        allowOutsideClick: false,
        showCancelButton: false,
        confirmButtonText: "OK",
      });
    }
  };
  
  

  const onFileChange1 = (e) => {
    setValues({
      ...values,
      error: false,
      img1: URL.createObjectURL(e.target.files[0]),
    });
    setImage1(e.target.files[0]);
  };
  const onFileChange2 = (e) => {
    setValues({
      ...values,
      error: false,
      img2: URL.createObjectURL(e.target.files[0]),
    });
    setImage2(e.target.files[0]);
  };
  const onFileChange3 = (e) => {
    setValues({
      ...values,
      error: false,
      img3: URL.createObjectURL(e.target.files[0]),
    });
    setImage3(e.target.files[0]);
  };
  const onFileChange4 = (e) => {
    setValues({
      ...values,
      error: false,
      img4: URL.createObjectURL(e.target.files[0]),
    });
    setImage4(e.target.files[0]);
  };
  const iconformat = (cell, row) => {
    return "<img src='" + cell + "' style='height:50px;'/>";
  };
  const name = (cell, row) => {
    return (
      <span>
        <div id="data">{row.name}</div>
      </span>
    );
  };
  const onFileChange = (e) => {
    setValues({ ...values, error: false, file: e.target.files[0] });
  };
  const descriptionformat = (cell, row) => {
    return <div className="col-md-12">{cell}</div>;
  };

  const handleChange = (name) => (e) => {
    if (name === "startDate") {
      loadData1("start", e.target.value);
    } else {
      loadData1("end", e.target.value);
    }
  };

  const offer = (cell, row, extraData, index) => {
    const handleChange = (status) => (e) => {
      Swal.fire({
        title:
          status == 1 ? `Enable Offer ${row.name}` : `Remove Offer ${row.name}`,
        text: "",
        icon: "question",
        allowOutsideClick: false,
        confirmButtonText: "Yes",
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          const requestUrl =  `${ENABLE_OFFER_PATH}?offer_status=${status}&mobile_no=${row.mobile_no}`
             privateApiCall(requestUrl,'GET')
             .then((res) => {
              if (res.status === 200) {
                var selections = data;
                selections[index].offer_status = status;

                setValues({ ...values, data: selections });
              }
            });
       
          
        }
      });
    };
    if (row.offer_status == 1) {
      return (
        <div>
          <i>
            <FaRegCheckSquare
              color="#769A0F"
              onClick={handleChange(0)}
              size="30"
            />
          </i>
        </div>
      );
    } else {
      return (
        <div>
          <i>
            <FaRegSquare color="#98a6ad" onClick={handleChange(1)} size="30" />
          </i>
        </div>
      );
    }
  };

  const dataTable = () => {
    return (
      <div id="wrapper">
        <Topbar backgroundColor="#0baae5" />
        <Sidebar type="profiles"/>
        <div className="content-page">
          <div className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box">
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          {" "}
                          <Link to="/organisation/dashboard">Dashboard</Link>
                        </li>
                        <li className="breadcrumb-item active">Customer</li>
                      </ol>
                    </div>
                    <h4 className="page-title">Customer</h4>
                  </div>
                </div>
              </div>
              <div className="card-box">
              <div className="col-md-12">

                
              <div className="row container-fluid"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center"
                    }}
                  > 
                  <div className="col-md-3 ">
                    <label>Start Date</label>
                    <input
                      type="date"
                      className="form-control"
                      style={{ marginTop: "5px" }}
                      value={startDate}
                      placeholder="Start Date"
                      onChange={handleChange("startDate")}
                      required
                    ></input>
                  </div>
                  <div className="col-md-3 ">
                    <label>End Date</label>
                    <input
                      type="date"
                      className="form-control"
                      style={{ marginTop: "5px" }}
                      value={endDate}
                      placeholder="End Date"
                      onChange={handleChange("endDate")}
                      required
                    />
                  </div>
                  <div  style={{ position: 'relative', marginLeft: 'auto', }}>
                        <input
                          type="text"
                          placeholder="Search..."
                          className="form-control"
                          style={{ width: '200px', paddingLeft: '35px', boxSizing: 'border-box', marginLeft: "auto" }}
                          onChange={(e) => {
                            handleSearch(e);
                            if (e.target.value.trim() === '') {
                              e.target.nextElementSibling.style.display = 'inline-block';
                            } else {
                              e.target.nextElementSibling.style.display = 'none';
                            }
                          }}
                       />
                         <IoSearch
                                  style={{
                                    position: "absolute",
                                    left: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                  }}
                                />
                      </div>
                  </div>

              </div>

              <div style={{ width: "98%", marginTop: '20px' }}>
                  <TableContainer component={Paper}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell align="center">S.No</TableCell>
                          <TableCell align="center">Name</TableCell>
                          <TableCell align="center">Email</TableCell>
                          <TableCell align="center">Mobile</TableCell>
                          <TableCell align="center">Subscription</TableCell>
                          <TableCell align="center">Validity</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {data.map((row, index) => (
                          <TableRow key={index}>
                            <TableCell align="center">{row.sno}</TableCell>
                            <TableCell align="center">{row.name}</TableCell>
                            <TableCell align="center">{row.email}</TableCell>
                            <TableCell align="center">
                              {row.mobile_no}
                            </TableCell>
                            <TableCell align="center">{row.sub}</TableCell>
                            <TableCell align="center">{row.val}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  return <React.Fragment>{dataTable()}</React.Fragment>;
};

export default Customer;
